import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M44.9701 15.5599L37.2601 19.2999H33.0801L25.3701 15.5599C25.3701 15.5599 14.8001 29.65 12.6001 51.45H57.7401C55.5401 29.65 44.9701 15.5599 44.9701 15.5599Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M68.9301 4.77002C68.9301 4.77002 69.48 10.82 63.21 12.26C63.21 12.26 61.23 18.54 54.73 15.89C54.73 15.89 51.32 22.5 44.38 18.09L42.29 3.55994L67.61 1.02991L68.9301 4.77002Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M1.4102 4.77002C1.4102 4.77002 0.860174 10.82 7.13017 12.26C7.13017 12.26 9.11015 18.54 15.6102 15.89C15.6102 15.89 19.0201 22.5 25.9601 18.09L28.0502 3.55994L2.73015 1.02991L1.4102 4.77002Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </g>
  )
}
